import React from "react"
import PropTypes from "prop-types"
import { P } from "./styles"

const HelpText = ({ children, simpleForm }) => (
  <P size="small" simpleForm={simpleForm}>
    {children}
  </P>
)

HelpText.propTypes = {
  children: PropTypes.node
}

export default HelpText
